import React, { useState, useEffect } from "react";
import Header from "../../layout/Header";
import swal from "sweetalert";
import { getSupportData } from "../../../services/services";
import Paginated from "./Paginated";
import { COLUMNS } from "./column"
import { Link } from "react-router-dom";
import { getDisplayDate } from "../../../utils/helper";

const Support = () => {
    const [loader, setLoader] = useState(false);
    const [supportList, setSupportList] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);

    useEffect(() => {
        fetchSupportDetails(1, pageSize);
    }, []);

    const fetchSupportDetails = async (page, limit) => {
        setLoader(true);

        let tempToken = JSON.parse(
            localStorage.getItem("token_gen")
        );

        const res = await getSupportData(
            tempToken?.access_token,
            page,
            limit
        );

        if (res.message === "Success") {

            const data = res?.data || [];

            const formattedData = data.map((item) => {
                return {
                    ...item,
                    createdAt: getDisplayDate(item.createdAt),
                    action: (
                        <Link to={`/customer-view/${item.customerCode}`}>
                            View Details
                        </Link>
                    ),
                };
            });

            setSupportList(formattedData);
            setCurrentPage(page);
            setPageSize(limit);
            setTotalCount(data?.length || 0);
        }

        setLoader(false);
    };

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div><div></div><div></div><div></div>
                        <div></div><div></div><div></div><div></div>
                    </div>
                </div>
            )}

            <Header name={"Retailer Request"} />

            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__customersCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4>Retailer Request Details</h4>
                            </div>
                        </div>

                        <div className="dashboard__body">
                            <Paginated
                                columns={COLUMNS}
                                data={supportList || []}
                                fetchSupportDetails={fetchSupportDetails}
                                totalCount={totalCount}
                                currentPage={currentPage}
                                pageSize={pageSize}
                                setPageSizeData={setPageSize}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Support;
